

import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import {
  getCategoryServ,
  addCategoryServ,
  deleteCategoryServ,
  updateCategoryServ,
} from "../../services/category.service";
import { triggerFileDownload } from "../../utils/fileDownload";
import {
  exportOrderServ,
  getBookingListServ,
  updateBookingServ,
} from "../../services/bookingDashboard.services";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import NoRecordFound from "../../Components/NoRecordFound";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { IMAGE_BASE_URL } from "../../utils/api_base_url_configration";


/* ─── Scoped styles ─────────────────────────────────── */
const styles = `
  .ol-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'Segoe UI', sans-serif;
  }

  /* stat grid */
  .ol-stat-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;
    margin-bottom: 22px;
  }
  @media (max-width: 1100px) { .ol-stat-grid { grid-template-columns: repeat(2,1fr); } }
  @media (max-width: 600px)  { .ol-stat-grid { grid-template-columns: 1fr; } }

  .ol-stat-card {
    background: #fff;
    border-radius: 14px;
    padding: 16px 18px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .ol-stat-icon {
    width: 42px;
    height: 42px;
    border-radius: 11px;
    background: #fdf2f1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #a60808;
    flex-shrink: 0;
  }
  .ol-stat-val {
    font-size: 22px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1;
  }
  .ol-stat-lbl {
    font-size: 14px;
    color: #828282;
    margin-top: 4px;
  }

  /* toolbar */
  .ol-toolbar {
    background: #fff;
    border-radius: 14px;
    padding: 16px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }
  .ol-toolbar-title {
    font-size: 18px;
    font-weight: 700;
    color: #1c0a0a;
  }
  .ol-toolbar-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
  .ol-select {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 14px;
    color: #555;
    background: #f9f9f9;
    outline: none;
    cursor: pointer;
  }
  .ol-select:focus { border-color: #f0c0b8; }

  .ol-btn-red {
    height: 40px;
    padding: 0 20px;
    border-radius: 10px;
    background: #a60808;
    color: #fff;
    border: none;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 7px;
    white-space: nowrap;
  }
  .ol-btn-red:hover { background: #a93226; }
  .ol-btn-red i { font-size: 15px; }

  /* dropdown wrapper */
  .ol-download-wrap { position: relative; }
  .ol-dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    background: #fff;
    border: 1px solid #f0eded;
    border-radius: 10px;
    padding: 6px;
    z-index: 100;
    min-width: 170px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  }
  .ol-dropdown-item {
    display: block;
    width: 100%;
    padding: 9px 14px;
    font-size: 14px;
    color: #444;
    background: none;
    border: none;
    border-radius: 7px;
    text-align: left;
    cursor: pointer;
  }
  .ol-dropdown-item:hover { background: #fdf2f1; color: #a60808; }

  /* table */
  .ol-table-wrap {
    background: #fff;
    border-radius: 14px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }
  .ol-table-scroll { overflow-x: auto; }
  .ol-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13.5px;
  }
  .ol-table thead tr { background: #fdf2f1; }
  .ol-table th {
    padding: 14px 16px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
  }
  .ol-table td {
    padding: 14px 16px;
    color: #444;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
  }
  .ol-table tbody tr:hover td { background: #fdfafa; }

  /* cells */
  .ol-oid { font-size: 12.5px; color: #888; font-family: monospace; font-weight: 600; }
  .ol-date-main { font-size: 14px; color: #333; }
  .ol-date-sub  { font-size: 11px; color: #bbb; margin-top: 2px; }

  .ol-avatar-cell { display: flex; align-items: center; gap: 10px; }
  .ol-av {
    width: 32px; height: 32px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  }
  .ol-av-initials {
    width: 32px; height: 32px;
    border-radius: 50%;
    background: #fdf2f1;
    display: flex; align-items: center; justify-content: center;
    font-size: 11px; font-weight: 700; color: #a60808;
    flex-shrink: 0;
  }
  .ol-av-name { font-size: 14px; color: #333; font-weight: 500; }

  .ol-pay-info { font-size: 14px; line-height: 1.8; color: #555; }
  .ol-pay-up   { color: #27ae60; font-weight: 600; }
  .ol-pay-no   { color: #a60808; font-weight: 600; }
  .ol-pay-eye  {
    background: none; border: none; cursor: pointer;
    color: #2980b9; font-size: 14px; padding: 0 4px;
    vertical-align: middle;
  }

  /* status select + update btn */
  .ol-status-sel {
    width: 100%;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #f0eded;
    padding: 0 8px;
    font-size: 14px;
    color: #444;
    background: #f9f9f9;
    outline: none;
  }
  .ol-status-sel:focus { border-color: #f0c0b8; }
  .ol-upd-btn {
    margin-top: 7px;
    width: 100%;
    height: 30px;
    border-radius: 7px;
    background: #1c0a0a;
    color: #fff;
    border: none;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.18s;
  }
  .ol-upd-btn:hover:not(:disabled) { background: #a60808; }
  .ol-upd-btn:disabled { opacity: 0.55; cursor: default; }

  /* view btn */
  .ol-view-btn {
    height: 34px;
    padding: 0 16px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: #fff;
    font-size: 14px;
    color: #555;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    transition: all 0.18s;
    white-space: nowrap;
  }
  .ol-view-btn:hover { background: #fdf2f1; border-color: #f0c0b8; color: #a60808; }
  .ol-view-btn i { font-size: 14px; }

  /* pagination */
  .ol-pagination {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 12px;
    padding: 16px 20px;
    border-top: 1px solid #f7f5f5;
  }
  .ol-show-row { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #888; }
  .ol-page-btns { display: flex; align-items: center; gap: 5px; }
  .ol-pg-btn {
    width: 34px; height: 34px;
    border-radius: 9px;
    border: 1px solid #f0eded;
    background: #fff;
    font-size: 14px;
    color: #555;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.18s;
  }
  .ol-pg-btn.active { background: #a60808; color: #fff; border-color: #a60808; }
  .ol-pg-btn:hover:not(.active):not(:disabled) { background: #fdf2f1; color: #a60808; }
  .ol-pg-btn:disabled { opacity: 0.4; cursor: default; }

  /* skeleton rows */
  .ol-skel-cell { padding: 14px 16px; border-top: 1px solid #f7f5f5; }
`;

/* ─── stat icon map ─────────────────────────────────── */
const STAT_ICONS = [
  "ti-shopping-bag",
  "ti-clock",
  "ti-upload",
  "ti-credit-card",
  "ti-package",
  "ti-truck",
  "ti-circle-check",
  "ti-circle-x",
];

function OrderList() {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [order, setOrder] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const handleOpenPaymentModal = () => setShowPaymentModal(true);
  const handleClosePaymentModal = () => setShowPaymentModal(false);
  const [statics, setStatics] = useState(null);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);

    const getImageUrl = (image) => {
    if (!image) return "";
    if (image.startsWith("http")) return image;
    return `${IMAGE_BASE_URL}${image}`;
  };

  const getPreviewImage = (img) => {
  if (!img) return "";
  if (img.startsWith("blob:")) return img;
  return getImageUrl(img);
};


  const [payload, setPayload] = useState({
    searchKey: "",
    status: "",
    pageNo: 1,
    pageCount: 10,
    sortByField: "",
  });
  const [showSkelton, setShowSkelton] = useState(false);

  const handleGetCategoryFunc = async () => {
    if (list.length === 0) setShowSkelton(true);
    try {
      let response = await getBookingListServ({ ...payload });
      setOrder(response?.data?.data);
      setList(response?.data?.data);
      setStatics(response?.data?.documentCount);
    } catch (error) {}
    setShowSkelton(false);
  };

  const staticsArr = [
    { title: "Total Order",         count: statics?.totalCount,            icon: STAT_ICONS[0] },
    { title: "Order Received",      count: statics?.pendingCount,          icon: STAT_ICONS[1] },
    { title: "Payment Ss Upload",   count: statics?.paymentSsUploadCount,  icon: STAT_ICONS[2] },
    { title: "Payment Confirmed",   count: statics?.orderPlacedCount,      icon: STAT_ICONS[3] },
    { title: "Order Packed",        count: statics?.orderPackedCount,      icon: STAT_ICONS[4] },
    { title: "Order Dispatched",    count: statics?.orderDispatchCount,    icon: STAT_ICONS[5] },
    { title: "Completed Order",     count: statics?.completedCount,        icon: STAT_ICONS[6] },
    { title: "Cancelled Order",     count: statics?.cancelledCount,        icon: STAT_ICONS[7] },
  ];

  useEffect(() => {
    handleGetCategoryFunc();
  }, [payload]);

  const [isLoading, setIsLoading] = useState(false);
  const [addFormData, setAddFormData] = useState({
    name: "", image: "", status: "", show: false, imgPrev: "", specialApperence: "",
  });

  const resolveShippingMethod = (booking) => {
    const normalize = (s = "") => s.trim().toLowerCase();
    const topLevel = booking?.shipping;
    const fromHistory = booking?.statusHistory?.find(
      (s) => s.status === "outForDelivery"
    )?.shipping;
    return normalize(topLevel || fromHistory || "");
  };

  const handleAddCategoryFunc = async () => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("name", addFormData?.name);
    formData.append("image", addFormData?.image);
    formData.append("status", addFormData?.status);
    formData.append("specialApperence", addFormData?.specialApperence);
    try {
      let response = await addCategoryServ(formData);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        setAddFormData({ name: "", image: "", status: "", show: false, imgPrev: "" });
        handleGetCategoryFunc();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Internal Server Error");
    }
    setIsLoading(false);
  };

  const [editFormData, setEditFormData] = useState({
    name: "", image: "", status: "", _id: "", imgPrev: "", specialApperence: "",
  });

  const handleUpdateCategoryFunc = async () => {
    setIsLoading(true);
    const formData = new FormData();
    if (editFormData?.image) formData?.append("image", editFormData?.image);
    formData?.append("name", editFormData?.name);
    formData?.append("status", editFormData?.status);
    formData?.append("_id", editFormData?._id);
    formData?.append("specialApperence", editFormData?.specialApperence);
    try {
      let response = await updateCategoryServ(formData);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        setEditFormData({ name: "", image: "", status: "", _id: "" });
        handleGetCategoryFunc();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Internal Server Error");
    }
    setIsLoading(false);
  };

  const deliveryStatusOptions = [
    { label: "All",                value: ""                },
    { label: "Order Received",     value: "pending"         },
    { label: "Payment Uploaded",   value: "paymentSsUpload" },
    { label: "Payment Confirmed",  value: "orderPlaced"     },
    { label: "Order Packed",       value: "orderPacked"     },
    { label: "Order Dispatch",     value: "outForDelivery"  },
    { label: "Completed",          value: "completed"       },
    { label: "Cancelled",          value: "cancelled"       },
  ];

  const [updatedStatuses, setUpdatedStatuses] = useState({});
  const [statusUpdating, setStatusUpdating] = useState({});

  const handleStatusChange = (bookingId, newStatus) => {
    setUpdatedStatuses((prev) => ({ ...prev, [bookingId]: newStatus }));
  };

  const handleStatusUpdate = async (bookingId) => {
    let status = updatedStatuses[bookingId];
    if (!status) return alert("Please select a status before updating.");
    setStatusUpdating((prev) => ({ ...prev, [bookingId]: true }));
    try {
      const res = await updateBookingServ({ id: bookingId, status });
      if (res.status === 200) {
        toast.success("Status updated successfully!");
        handleGetCategoryFunc();
      } else {
        toast.error(res?.data?.message || "Failed to update status");
      }
    } catch (err) {
      const apiMessage = err?.response?.data?.message;
      const productId  = err?.response?.data?.productId;
      if (apiMessage) {
        toast.error(productId ? `${apiMessage} (Product ID: ${productId})` : apiMessage);
      } else {
        toast.error("Something went wrong, please try again.");
      }
    } finally {
      setStatusUpdating((prev) => ({ ...prev, [bookingId]: false }));
    }
  };

  const [totalPages, setTotalPages] = useState(1);
  useEffect(() => {
    if (statics?.totalCount && payload.pageCount) {
      setTotalPages(Math.ceil(statics.totalCount / payload.pageCount));
    }
  }, [statics, payload.pageCount]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPayload({ ...payload, pageNo: newPage });
    }
  };

  const getStatusOptions = (currentStatus, shippingMethod) => {
    const normal = (s = "") => s.trim().toLowerCase();
    const normalized = normal(shippingMethod);
    const shippingText =
      normalized === "homedelivery" ? "Door Delivery"
      : normalized === "lorrypay"  ? "Pickup at Lorry Transport"
      : shippingMethod || "Unknown";

    switch (currentStatus) {
      case "pending":
        return [
          { label: "Order Received",            value: "pending"          },
          { label: "Payment Details Uploaded",  value: "paymentSsUpload"  },
          { label: "Cancelled",                 value: "cancelled"        },
        ];
      case "paymentSsUpload":
        return [
          { label: "Payment Details Uploaded",  value: "paymentSsUpload"  },
          { label: "Payment Confirmed",         value: "approved"         },
          { label: "Payment Rejected",          value: "ssRejected"       },
          { label: "Cancelled",                 value: "cancelled"        },
        ];
      case "approved":
      case "orderPlaced":
        return [
          { label: "Payment Confirm",  value: "orderPlaced" },
          { label: "Order Packed",     value: "orderPacked" },
          { label: "Cancelled",        value: "cancelled"   },
        ];
      case "orderPacked":
        return [
          { label: "Order Packed",    value: "orderPacked"    },
          { label: "Order Dispatch",  value: "outForDelivery" },
          { label: "Cancelled",       value: "cancelled"      },
        ];
      case "outForDelivery":
        return [
          { label: `Order Dispatch - ${shippingText}`, value: "outForDelivery" },
          { label: "Order Completed",                  value: "completed"      },
        ];
      case "completed":
        return [{ label: "Order Completed", value: "completed" }];
      case "cancelled":
        return [{ label: "Order Cancelled", value: "cancelled" }];
      case "ssRejected":
        return [
          { label: "Payment Rejected",          value: ""                 },
          { label: "Payment Details Uploaded",  value: "paymentSsUpload"  },
          { label: "Cancelled",                 value: "cancelled"        },
        ];
      default:
        return [
          { label: "Select Status",   value: ""        },
          { label: "Order Received",  value: "pending" },
          { label: "Cancelled",       value: "cancelled" },
        ];
    }
  };

  const handleDownload = async (format) => {
    setShowDownloadMenu(false);
    try {
      const response = await exportOrderServ(payload, format);
      const ext = format === "excel" ? "xlsx" : format;
      triggerFileDownload(response.data, `OrderList.${ext}`);
    } catch (err) {
      toast.error("Download failed");
    }
  };

  /* helper: customer name */
  const getCustomerName = (item) =>
    item?.address?.fullName ||
    [item?.userId?.firstName, item?.userId?.lastName].filter(Boolean).join(" ") ||
    "Guest";

  return (
    <div className="bodyContainer">
      <style>{styles}</style>
      <Sidebar selectedMenu="Order Management" selectedItem="Orders" />

      <div className="mainContainer">
        <TopNav pageTitle="Orders" pagePath="Home / Order Management / Orders" />

        <div className="ol-page">
          {/* ── Stat Cards ── */}
          <div className="ol-stat-grid">
            {staticsArr.map((v, i) => (
              <div className="ol-stat-card" key={i}>
                <div className="ol-stat-icon">
                  <i className={`ti ${v.icon}`} aria-hidden="true" />
                </div>
                <div>
                  <div className="ol-stat-val">{v.count ?? "—"}</div>
                  <div className="ol-stat-lbl">{v.title}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Toolbar ── */}
          <div className="ol-toolbar">
            <div className="ol-toolbar-title">Orders</div>
            <div className="ol-toolbar-right">
              <select
                className="ol-select"
                onChange={(e) => setPayload({ ...payload, status: e.target.value })}
              >
                {deliveryStatusOptions.map((s) => (
                  <option key={s.value} value={s.value}>{s.label}</option>
                ))}
              </select>

              <div className="ol-download-wrap">
                <button
                  className="ol-btn-red"
                  onClick={() => setShowDownloadMenu((p) => !p)}
                >
                  <i className="ti ti-download" aria-hidden="true" />
                  Download
                </button>
                {showDownloadMenu && (
                  <div className="ol-dropdown-menu">
                    <button className="ol-dropdown-item" onClick={() => handleDownload("txt")}>
                      Download as TXT
                    </button>
                    <button className="ol-dropdown-item" onClick={() => handleDownload("excel")}>
                      Download as Excel
                    </button>
                    <button className="ol-dropdown-item" onClick={() => handleDownload("csv")}>
                      Download as CSV
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* ── Table ── */}
          <div className="ol-table-wrap">
            <div className="ol-table-scroll">
              <table className="ol-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Order ID</th>
                    <th>Created</th>
                    <th>Customer</th>
                    <th>Payment</th>
                    <th>Status</th>
                    <th>Updated</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {showSkelton ? (
                    [...Array(10)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(8)].map((__, j) => (
                          <td key={j} className="ol-skel-cell">
                            <Skeleton height={18} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td colSpan="8" style={{ textAlign: "center", padding: "40px" }}>
                        <NoRecordFound />
                      </td>
                    </tr>
                  ) : (
                    list.map((item, index) => (
                      <tr key={index}>
                        {/* Sr */}
                        <td>{(payload.pageNo - 1) * payload.pageCount + index + 1}</td>

                        {/* Order ID */}
                        <td>
                          <span className="ol-oid">#{item?.orderId || "N/A"}</span>
                        </td>

                        {/* Created */}
                        <td>
                          <div className="ol-date-main">
                            {moment(item?.createdAt).format("DD MMM YYYY")}
                          </div>
                          <div className="ol-date-sub">
                            {moment(item?.createdAt).format("hh:mm A")}
                          </div>
                        </td>

                        {/* Customer */}
                        <td>
                          <div className="ol-avatar-cell">
                            {item?.userId?.profilePic ? (
                              <img
                                src={getImageUrl(item.userId.profilePic)}
                                alt="profile"
                                className="ol-av"
                              />
                            ) : (
                              <div className="ol-av-initials">
                                {getCustomerName(item)
                                  .split(" ")
                                  .map((n) => n[0])
                                  .join("")
                                  .toUpperCase()
                                  .slice(0, 2)}
                              </div>
                            )}
                            <span className="ol-av-name">{getCustomerName(item)}</span>
                          </div>
                        </td>

                        {/* Payment */}
                        <td>
                          <div className="ol-pay-info">
                            <div>Txn: #{item?.paymentId || "N/A"}</div>
                            <div>Mode: {item?.modeOfPayment || "—"}</div>
                            <div>Paid: Rs {item?.totalAmount || "—"}</div>
                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                              SS:{" "}
                              {item?.paymentSs ? (
                                <>
                                  <span className="ol-pay-up">Uploaded</span>
                                  <button
                                    className="ol-pay-eye"
                                    onClick={() => {
                                      setOrder(item);
                                      handleOpenPaymentModal();
                                    }}
                                    title="View screenshot"
                                  >
                                    <i className="ti ti-eye" aria-hidden="true" />
                                  </button>
                                </>
                              ) : (
                                <span className="ol-pay-no">Not Uploaded</span>
                              )}
                            </div>
                          </div>
                        </td>

                        {/* Status */}
                        <td style={{ minWidth: "160px" }}>
                          <select
                            className="ol-status-sel"
                            value={updatedStatuses[item._id] || item?.status}
                            onChange={(e) => handleStatusChange(item._id, e.target.value)}
                          >
                            {getStatusOptions(
                              item?.status,
                              resolveShippingMethod(item)
                            ).map((opt, idx) => (
                              <option key={idx} value={opt.value}>{opt.label}</option>
                            ))}
                          </select>
                          <button
                            className="ol-upd-btn"
                            onClick={() => handleStatusUpdate(item._id)}
                            disabled={statusUpdating[item._id]}
                          >
                            {statusUpdating[item._id] ? "Updating..." : "Update"}
                          </button>
                        </td>

                        {/* Updated */}
                        <td>
                          <div className="ol-date-main">
                            {moment(item?.updatedAt).format("DD MMM YYYY")}
                          </div>
                          <div className="ol-date-sub">
                            {moment(item?.updatedAt).format("hh:mm A")}
                          </div>
                        </td>

                        {/* Action */}
                        <td>
                          <button
                            className="ol-view-btn"
                            onClick={() => navigate(`/order-details/${item._id}`)}
                          >
                            <i className="ti ti-eye" aria-hidden="true" />
                            View
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* ── Pagination ── */}
            <div className="ol-pagination">
              <div className="ol-show-row">
                Show
                <select
                  className="ol-select"
                  style={{ height: "34px", padding: "0 10px" }}
                  value={payload.pageCount}
                  onChange={(e) =>
                    setPayload({ ...payload, pageCount: parseInt(e.target.value), pageNo: 1 })
                  }
                >
                  {[10, 25, 50, 100].map((v) => (
                    <option key={v} value={v}>{v}</option>
                  ))}
                </select>
                entries
              </div>

              <div className="ol-page-btns">
                <button
                  className="ol-pg-btn"
                  disabled={payload.pageNo === 1}
                  onClick={() => handlePageChange(payload.pageNo - 1)}
                >
                  <i className="ti ti-chevron-left" style={{ fontSize: "13px" }} />
                </button>

                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (
                    page === 1 ||
                    page === totalPages ||
                    (page >= payload.pageNo - 1 && page <= payload.pageNo + 1)
                  ) {
                    return (
                      <button
                        key={page}
                        className={`ol-pg-btn ${payload.pageNo === page ? "active" : ""}`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    );
                  } else if (
                    (page === payload.pageNo - 2 && page > 2) ||
                    (page === payload.pageNo + 2 && page < totalPages - 1)
                  ) {
                    return (
                      <button key={page} className="ol-pg-btn" disabled>
                        ...
                      </button>
                    );
                  }
                  return null;
                })}

                <button
                  className="ol-pg-btn"
                  disabled={payload.pageNo === totalPages}
                  onClick={() => handlePageChange(payload.pageNo + 1)}
                >
                  <i className="ti ti-chevron-right" style={{ fontSize: "13px" }} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Add Category Modal (unchanged) ── */}
      {addFormData?.show && (
        <div className="modal fade show d-flex align-items-center justify-content-center" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content" style={{ borderRadius: "16px", background: "#f7f7f5", width: "364px" }}>
              <div className="d-flex justify-content-end pt-4 pb-0 px-4">
                <img
                  src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
                  style={{ height: "20px", cursor: "pointer" }}
                  onClick={() => setAddFormData({ name: "", image: "", status: "", show: false, specialApperence: "" })}
                />
              </div>
              <div className="modal-body">
                <div className="d-flex justify-content-center w-100">
                  <div className="w-100 px-2">
                    <h5 className="mb-4">Add Category</h5>
                    <div className="p-3 border rounded mb-2">
                      {addFormData?.imgPrev ? (
                      <img src={getPreviewImage(addFormData?.imgPrev)} className="img-fluid w-100 shadow rounded" />
                      ) : (
                        <p className="mb-0 text-center">No Item Selected !</p>
                      )}
                    </div>
                    <label>Upload Image</label>
                    <input className="form-control" type="file"
                      onChange={(e) => setAddFormData({ ...addFormData, image: e.target.files[0], imgPrev: URL.createObjectURL(e.target.files[0]) })} />
                    <label className="mt-3">Name</label>
                    <input className="form-control" type="text"
                      onChange={(e) => setAddFormData({ ...addFormData, name: e.target.value })} />
                    <label className="mt-3">Status</label>
                    <select className="form-control"
                      onChange={(e) => setAddFormData({ ...addFormData, status: e.target.value })}>
                      <option value="">Select Status</option>
                      <option value={true}>Active</option>
                      <option value={false}>Inactive</option>
                    </select>
                    <label className="mt-3">Special Apperence</label>
                    <select className="form-control"
                      onChange={(e) => setAddFormData({ ...addFormData, specialApperence: e.target.value })}
                      value={addFormData?.specialApperence}>
                      <option value="">Select Status</option>
                      <option value="Home">Home</option>
                    </select>
                    <button
                      className="btn btn-success w-100 mt-4"
                      onClick={addFormData?.name && addFormData?.status && addFormData?.image && !isLoading ? handleAddCategoryFunc : undefined}
                      disabled={!addFormData?.name || !addFormData?.status || !addFormData?.image || isLoading}
                      style={{ opacity: !addFormData?.name || !addFormData?.status || !addFormData?.image || isLoading ? "0.5" : "1" }}
                    >
                      {isLoading ? "Saving..." : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {addFormData?.show && <div className="modal-backdrop fade show"></div>}

      {/* ── Edit Category Modal (unchanged) ── */}
      {editFormData?._id && (
        <div className="modal fade show d-flex align-items-center justify-content-center" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content" style={{ borderRadius: "16px", background: "#f7f7f5", width: "364px" }}>
              <div className="d-flex justify-content-end pt-4 pb-0 px-4">
                <img
                  src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
                  style={{ height: "20px", cursor: "pointer" }}
                  onClick={() => setEditFormData({ name: "", image: "", status: "", specialApperence: "", _id: "" })}
                />
              </div>
              <div className="modal-body">
                <div className="d-flex justify-content-center w-100">
                  <div className="w-100 px-2">
                    <h5 className="mb-4">Update Category</h5>
                    <div className="p-3 border rounded mb-2">
                     <img src={getPreviewImage(editFormData?.imgPrev)} className="img-fluid w-100 shadow rounded" />
                    </div>
                    <label>Upload Image</label>
                    <input className="form-control" type="file"
                      onChange={(e) => setEditFormData({ ...editFormData, image: e.target.files[0], imgPrev: URL.createObjectURL(e.target.files[0]) })} />
                    <label className="mt-3">Name</label>
                    <input className="form-control" type="text"
                      onChange={(e) => setEditFormData({ ...editFormData, name: e.target.value })}
                      value={editFormData?.name} />
                    <label className="mt-3">Status</label>
                    <select className="form-control"
                      onChange={(e) => setEditFormData({ ...editFormData, status: e.target.value })}
                      value={editFormData?.status}>
                      <option value="">Select Status</option>
                      <option value={true}>Active</option>
                      <option value={false}>Inactive</option>
                    </select>
                    <label className="mt-3">Special Apperence</label>
                    <select className="form-control"
                      onChange={(e) => setEditFormData({ ...editFormData, specialApperence: e.target.value })}
                      value={editFormData?.specialApperence}>
                      <option value="">Select Status</option>
                      <option value="Home">Home</option>
                    </select>
                    {editFormData?.name && editFormData?.status ? (
                      <button className="btn btn-success w-100 mt-4" onClick={!isLoading ? handleUpdateCategoryFunc : undefined}>
                        {isLoading ? "Saving..." : "Submit"}
                      </button>
                    ) : (
                      <button className="btn btn-success w-100 mt-4" style={{ opacity: "0.5" }}>Submit</button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {editFormData?._id && <div className="modal-backdrop fade show"></div>}

      {/* ── Payment Screenshot Modal (unchanged) ── */}
      <Modal show={showPaymentModal} onHide={handleClosePaymentModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Payment Screenshot</Modal.Title>
        </Modal.Header>
   <Modal.Body className="text-center"><img src={getImageUrl(order?.paymentSs)} alt="Payment Screenshot" className="img-fluid rounded" /> 

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosePaymentModal}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default OrderList;